<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content">
			<div class="modal__head">
				<div class="modal__head__title">Uploading a file or plan</div>
				<div class="modal__head__subtitle">Maximum file size is 25mb</div>
			</div>
			<div class="modal__content">
				<ul>
					<div class="col md-12">
						<div class="modal__content--sml">
						Please upload any supporting files or plans here. Only one file may be uploaded so please create a .zip file to upload multiple files, or follow up with an email.
						</div>
					</div>
				</ul>
				<div class="clearfix"></div>
				<button class="primary" @click="closeModaler">Close</button>
			</div>
		</div>
	</appBaseModal>
</template>

<script>
    import BaseModal from './BaseModal';
	export default {
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'UploadingFileModal',
			}
		},
		methods : {
			closeModaler(){
				return this.$store.commit('closeModal', '');
			}
		},
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/UploadingFileModal.vue